import { BaseEntityDto } from '@fleet-beat/core';

export interface PriceDto extends BaseEntityDto {
  id?: string;
  object?: string;
  active?: boolean;
  billing_scheme?: string;
  created?: number;
  currency?: string;
  livemode?: boolean;
  nickname?: string;
  product?: string;
  recurring?: {
    interval?: string;
    interval_count?: number;
    usage_type?: string;
  };
  tax_behavior?: string;
  type?: string;
  amount?: number;
  unit_amount?: number;
  unit_amount_decimal?: string;
}
